





















import Base from "@/controllers/base.ts";
import { Component } from "vue-property-decorator";
import Crumbs from "@/components/Crumbs/index.vue";
import CContentTop from "@/components/CContentTop.vue";
import End from "@/components/End/index.vue";
import { Button } from "ant-design-vue";

@Component({
  name: "ReleaseDetail",
  components: {
    Crumbs,
    CContentTop,
    End,
    AButton: Button
  }
})
export default class ReleaseDetail extends Base {
  private noticeId = "";
  private dataSource: any = {};
  private nearbyLoading = false;

  private created() {
    const bread: Common.CBread[] = [];
    this._created(bread);
    this.noticeId = (this.$route.query.noticeId as string) || "";
    this.noticeId && this.getDetail();
  }

  private async getDetail() {
    this.$message.destroy();
    const res = await this.$api.ReleaseDetail(this.noticeId);
    if (res && res.code === 200) {
      this.dataSource = res.data;
    }
  }
}
